import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { Pegar_dados_planos_ciclos } from "../../services/api";

const ComparativoPlanos = (props) => {
    const [data, setData] = useState([]);

    // Array de unidades seguindo o seu modelo padrão
    const unidades = [
        '', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara',
        'Nilopolis', '', '', 'Seropédica', 'Barra', 'Campo Grande',
        'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio'
    ];

    // Estilos baseados no seu componente qtd_turmas
    const styles = {
        bg2026: { backgroundColor: 'rgba(0, 123, 255, 0.05)' },
        bg2025: { backgroundColor: 'rgba(220, 53, 69, 0.05)' },
        bg2024: { backgroundColor: 'rgba(255, 193, 7, 0.05)' },
        header2026: { backgroundColor: '#007bff', color: 'white' },
        header2025: { backgroundColor: '#dc3545', color: 'white' },
        header2024: { backgroundColor: '#ffc107', color: '#000' }
    };

    const fetchData = async () => {
        try {
            const response = await Pegar_dados_planos_ciclos();
            // Já vem ordenado por sec e dsc do SQL, então apenas setamos o state
            setData(response);
            console.log("Dados dos planos carregados:", response);
        } catch (error) {
            console.error("Erro ao buscar dados dos planos:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [props.di, props.df]); // Mantendo as props de dependência caso precise filtrar datas depois

    // Função de renderização com setas mantida e adaptada do seu modelo
    const renderValue = (current, previous, isTotal = false) => {
        const cur = parseInt(current) || 0;
        const prev = parseInt(previous) || 0;

        const arrowUp = isTotal ? "#90ee90" : "green";
        const arrowDown = isTotal ? "#ffcccb" : "red";

        if (cur > prev) {
            return (
                <span className={isTotal ? "fw-bold" : "fw-bold text-success"}>
                    {cur} <small style={{ fontSize: '0.75em', color: isTotal ? arrowUp : 'inherit' }}>▲</small>
                </span>
            );
        } else if (cur < prev) {
            return (
                <span className={isTotal ? "fw-bold" : "fw-bold text-danger"}>
                    {cur} <small style={{ fontSize: '0.75em', color: isTotal ? arrowDown : 'inherit' }}>▼</small>
                </span>
            );
        }
        return <span className={isTotal ? "fw-bold" : ""}>{cur}</span>;
    };

    // Calculador de totais do rodapé
    const totals = data.reduce((acc, item) => {
        const categories = ['total', 'novos', 'renov'];
        const cycles = ['26_27', '25_26', '24_25'];

        cycles.forEach(c => {
            categories.forEach(cat => {
                const key = `${cat}_${c}`;
                acc[key] = (acc[key] || 0) + (parseInt(item[key]) || 0);
            });
        });
        return acc;
    }, {});

    return (
        <div className="media mt-4">
            <h2 className="mb-2 text-center fw-light text-secondary">Evolução de Planos por Unidade</h2>
            {/* <p className="mb-4 text-center text-muted small text-uppercase">Comparativo de Novos e Renovados (Ciclos)</p> */}

            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered size="sm" className="text-center align-middle bg-white m-0">
                    <thead className="table-dark text-nowrap">
                        <tr>
                            <th rowSpan="2" className="align-middle bg-dark">Unidade</th>
                            <th rowSpan="2" className="align-middle bg-dark">Plano / Descrição</th>
                            <th colSpan="3" style={styles.header2026}>Ciclo 26/27 (vs 25/26)</th>
                            <th colSpan="3" style={styles.header2025}>Ciclo 25/26 (vs 24/25)</th>
                            <th colSpan="3" style={styles.header2024}>Ciclo 24/25</th>
                        </tr>
                        <tr className="small">
                            {/* Sub-cabeçalho 25/26 */}
                            <th style={{ backgroundColor: '#0056b3', color: 'white' }}>Total</th>
                            <th className="bg-primary bg-opacity-10 text-dark">Novos</th>
                            <th className="bg-primary bg-opacity-10 text-dark">Renovados</th>

                            {/* Sub-cabeçalho 24/25 */}
                            <th style={{ backgroundColor: '#b02a37', color: 'white' }}>Total</th>
                            <th className="bg-danger bg-opacity-10 text-dark">Novos</th>
                            <th className="bg-danger bg-opacity-10 text-dark">Renovados</th>

                            {/* Sub-cabeçalho 23/24 */}
                            <th className="bg-warning text-dark fw-bold">Total</th>
                            <th className="bg-warning bg-opacity-10 text-dark">Novos</th>
                            <th className="bg-warning bg-opacity-10 text-dark">Renovados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, idx) => (
                            <tr key={idx}>
                                <td className="text-start fw-bold bg-light ps-3 text-nowrap">
                                    {unidades[parseInt(item.sec)] || `Unid. ${item.sec}`}
                                </td>
                                <td className="text-start ps-2">{item.dsc}</td>

                                {/* Dados Ciclo 25/26 comparando com 24/25 */}
                                <td style={{ backgroundColor: '#6ab2ff', color: 'white' }}>
                                    {renderValue(item.total_26_27, item.total_25_26, true)}
                                </td>
                                <td style={styles.bg2026}>{renderValue(item.novos_26_27, item.novos_25_26)}</td>
                                <td style={styles.bg2026}>{renderValue(item.renov_26_27, item.renov_25_26)}</td>

                                {/* Dados Ciclo 24/25 comparando com 23/24 */}
                                <td style={{ backgroundColor: '#ff7a87', color: 'white' }}>
                                    {renderValue(item.total_25_26, item.total_24_25, true)}
                                </td>
                                <td style={styles.bg2025}>{renderValue(item.novos_25_26, item.novos_24_25)}</td>
                                <td style={styles.bg2025}>{renderValue(item.renov_25_26, item.renov_24_25)}</td>

                                {/* Dados Ciclo 23/24 (Baseline, sem setas) */}
                                <td style={styles.header2024} className="fw-bold">
                                    {item.total_24_25 || 0}
                                </td>
                                <td style={styles.bg2024}>{item.novos_24_25 || 0}</td>
                                <td style={styles.bg2024}>{item.renov_24_25 || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                    {/* <tfoot className="fw-bolder border-top border-dark">
                        <tr className="bg-light">
                            <td colSpan="2" className="text-end pe-3">TOTAL GERAL:</td>

                            <td style={{ backgroundColor: '#6ab2ff', color: 'white' }}>{totals.total_26_27}</td>
                            <td style={styles.bg2026}>{totals.novos_26_27}</td>
                            <td style={styles.bg2026}>{totals.renov_26_27}</td>

                            <td style={{ backgroundColor: '#ff7a87', color: 'white' }}>{totals.total_25_26}</td>
                            <td style={styles.bg2025}>{totals.novos_25_26}</td>
                            <td style={styles.bg2025}>{totals.renov_25_26}</td>

                            <td style={styles.header2024}>{totals.total_24_25}</td>
                            <td style={styles.bg2024}>{totals.novos_24_25}</td>
                            <td style={styles.bg2024}>{totals.renov_24_25}</td>
                        </tr>
                    </tfoot> */}
                </Table>
            </div>
        </div>
    );
};

export default ComparativoPlanos;